import { CustomModalCell } from '../../components/custom-modal-cell';
import { OrderGroupCell } from './components/order-group-cell';

export const FORM_NAME = 'orderGroupForm';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const COLUMNS = [
	{ id: 'title', width: '300px' },
	{ id: 'value', customComponent: CustomModalCell, width: '300px' },
	{ id: 'sub_value', customComponent: OrderGroupCell, width: '300px' },
];

export const DATE_FORMAT = 'DD.MM.YYYY';

export const REGULAR_ROUTE_REQUIRED_FIELDS = [
	'type_id',
	'name',
	'period_id',
	'address_from',
	'date',
	'address_to',
	'days',
	'weight',
	'volume',
];

export const INDIVIDUAL_ROUTE_REQUIRED_FIELDS = [
	'type_id',
	'name',
	'config_id',
	'transport_type_id',
	'transport_count',
	'weight',
	'volume',
	'work_time_from',
	'work_time_to',
	'pickup_time_from',
	'pickup_time_to',
	'drop_time_from',
	'drop_time_to',
	'compatibilities',
];

export const INDIVIDUAL_ROUTE_WITH_AUTOPARK_REQUIRED_FIELDS = [
	'type_id',
	'name',
	'config_id',
	'autopark_ids',
	'tariff_type_id',
	'work_time_from',
	'work_time_to',
	'pickup_time_from',
	'pickup_time_to',
	'drop_time_from',
	'drop_time_to',
	'compatibilities',
];

export const INDIVIDUAL_FORM_FIELDS = [
	'type_id',
	'name',
	'config_id',
	'autopark_ids',
	'tariff_type_id',
	'transport_type_id',
	'transport_count',
	'weight',
	'volume',
	'weight_recycling_rate',
	'volume_recycling_rate',
	'weight_rate',
	'volume_rate',
	'points_amount',
	'speed_multiplier',
	'work_time_from',
	'work_time_to',
	'pickup_time_from',
	'pickup_time_to',
	'pickup_time',
	'drop_time_from',
	'drop_time_to',
	'drop_time',
	'compatibilities',
];

export const COMPATIBILITIES_REQUIRED_FIELDS = ['mode_id', 'compatibility'];
